import validation from './validation/index.validation';
import features from './features/index.features';
import staticData from './staticData/index.staticData';
import appRoutes from './appRoutes/index.appRoutes';

const common = {
  namespaced: true,
  modules: {
    validation,
    features,
    staticData,
    appRoutes,
  },
};

export default common;
